<template>
  <div class="app-container">
    <el-card shadow="never" class="query-card">
      <el-form :model="query" ref="queryForm" :inline="true" v-show="showSearch">
        <el-form-item label="部门名称" prop="deptName">
          <el-input
            v-model="query.deptName"
            placeholder="请输入部门名称"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="query.status" placeholder="部门状态" clearable size="small">
            <el-option label="正常" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
          >新增</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button
            type="info"
            plain
            icon="el-icon-sort"
            size="mini"
            @click="toggleExpandAll"
          >展开/折叠</el-button>
        </el-col>
        <div class="right-tool">
          <el-tooltip class="item" effect="dark" :content="showSearch ? '隐藏搜索' : '显示搜索'" placement="top">
            <el-button size="mini" circle icon="el-icon-search" @click="showSearch=!showSearch" />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="刷新" placement="top">
            <el-button size="mini" circle icon="el-icon-refresh" @click="fetchList" />
          </el-tooltip>
        </div>
      </el-row>

      <el-table
        v-if="refreshTable"
        v-loading="loading"
        :data="deptList"
        row-key="id"
        :default-expand-all="isExpandAll"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        border
      >
        <el-table-column prop="deptName" label="部门名称" width="240"></el-table-column>
        <el-table-column v-if="isSuperAdminUser" label="投放部门ID(A)" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.adsDeptId != null && scope.row.adsDeptId !== '' ? scope.row.adsDeptId : '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="isSuperAdminUser" label="投放部门名称(A)" min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.adsDeptName ? scope.row.adsDeptName : '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="100" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
                {{ scope.row.status === 1 ? '正常' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime" width="180">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" :width="isSuperAdminUser ? 300 : 180">
          <template slot-scope="scope">
            <div class="operation-cell">
              <el-button
                v-if="isSuperAdminUser"
                size="mini"
                type="text"
                icon="el-icon-connection"
                @click="handleAdsDeptBind(scope.row)"
              >投放映射</el-button>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
              >修改</el-button>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-plus"
                @click="handleAdd(scope.row)"
              >新增</el-button>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                class="danger-text"
                @click="handleDelete(scope.row)"
              >删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加或修改部门对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="上级部门" prop="parentId">
               <el-cascader
                v-model="form.parentId"
                :options="deptOptions"
                :props="{ value: 'id', label: 'deptName', children: 'children', checkStrictly: true, emitPath: false }"
                clearable
                placeholder="选择上级部门"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门名称" prop="deptName">
              <el-input v-model="form.deptName" placeholder="请输入部门名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="显示排序" prop="sort">
              <el-input-number v-model="form.sort" controls-position="right" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="负责人" prop="leader">
              <el-input v-model="form.leader" placeholder="请输入负责人" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入联系电话" maxlength="11" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="form.email" placeholder="请输入邮箱" maxlength="50" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门状态">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 超级管理员：维护本系统部门与投放系统(A)部门主键 sys_dept.dept_id -->
    <el-dialog title="部门与投放系统映射" :visible.sync="bindOpen" width="560px" append-to-body @open="loadAdsDeptOptions" @close="resetBindForm">
      <div style="color:#606266;margin-bottom:12px;line-height:1.5;">
        本系统部门：<strong>{{ bindDeptName }}</strong>（本系统 ID：<code>{{ bindAiDeptId }}</code>）
      </div>
      <div style="color:#909399;font-size:12px;margin-bottom:12px;line-height:1.5;">
        选择投放系统（A）的部门进行映射。选择「不映射（解除绑定）」可清除已有映射。
      </div>
      <el-form label-width="150px" size="small">
        <el-form-item label="投放系统部门">
          <el-select
            v-model="bindAdsDeptIdInput"
            filterable
            clearable
            placeholder="选择A系统部门"
            style="width: 100%"
            :loading="adsDeptOptionsLoading"
            @change="onAdsDeptSelect"
          >
            <el-option label="不映射（解除绑定）" value="" />
            <el-option
              v-for="d in adsDeptOptions"
              :key="d.deptId"
              :label="d.deptName + '（ID: ' + d.deptId + '）'"
              :value="String(d.deptId)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="投放部门名称(A)">
          <el-input
            v-model="bindAdsDeptNameInput"
            maxlength="128"
            show-word-limit
            placeholder="选择部门后自动填充"
            clearable
            readonly
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bindOpen = false">取 消</el-button>
        <el-button type="primary" :loading="bindSaving" @click="submitDeptBind">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDeptTree, createDept, updateDept, deleteDept, listDeptAdsBindsAll, saveDeptAdsBind } from '@/api/system/dept';
import { fetchAdsDeptTree } from '@/api/system/adsBind';
import { isSuperAdminUser } from '@/utils/permission';

export default {
  name: "Dept",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 表格树数据
      deptList: [],
      // 部门树选项
      deptOptions: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否展开，默认全部折叠
      isExpandAll: false,
      // 重新渲染表格状态
      refreshTable: true,
      // 查询参数
      query: {
        deptName: undefined,
        status: undefined
      },
      // 表单参数
      form: {},
      // 表单校验
      bindOpen: false,
      bindAiDeptId: undefined,
      bindDeptName: '',
      bindAdsDeptIdInput: '',
      bindAdsDeptNameInput: '',
      bindSaving: false,
      adsDeptOptions: [],
      adsDeptOptionsLoading: false,
      rules: {
        parentId: [
          { required: true, message: "上级部门不能为空", trigger: "blur" }
        ],
        deptName: [
          { required: true, message: "部门名称不能为空", trigger: "blur" }
        ],
        sort: [
          { required: true, message: "部门顺序不能为空", trigger: "blur" }
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        phone: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    isSuperAdminUser() {
      var appVm = this.$root && this.$root.$children && this.$root.$children[0];
      var user = appVm ? appVm.currentUser : null;
      if (!user) {
        return false;
      }
      return Number(user.id) === 1 || user.isAdmin === 1 || user.isAdmin === true;
    }
  },
  created() {
    this.fetchList();
  },
  methods: {
    /** 查询部门列表 */
    async fetchList() {
      this.loading = true;
      try {
        const response = await getDeptTree(this.query);
        this.deptList = response.data || [];
        if (this.isSuperAdminUser) {
          await this.mergeAdsDeptBindIntoTree();
        }
      } finally {
        this.loading = false;
      }
    },
    async mergeAdsDeptBindIntoTree() {
      try {
        const res = await listDeptAdsBindsAll();
        const pairs = (res && res.data) ? res.data : [];
        const map = {};
        pairs.forEach(function (p) {
          if (p && p.aiDeptId != null) {
            map[p.aiDeptId] = {
              adsDeptId: p.adsDeptId,
              adsDeptName: p.adsDeptName || ''
            };
          }
        });
        this.applyAdsBindMap(this.deptList, map);
      } catch (e) {
        console.warn('[mergeAdsDeptBindIntoTree]', e);
      }
    },
    applyAdsBindMap(nodes, map) {
      if (!nodes || !nodes.length) {
        return;
      }
      const self = this;
      nodes.forEach(function (n) {
        const info = map[n.id];
        if (info != null && typeof info === 'object' && !Array.isArray(info)) {
          n.adsDeptId = info.adsDeptId;
          n.adsDeptName = info.adsDeptName || undefined;
        } else {
          n.adsDeptId = undefined;
          n.adsDeptName = undefined;
        }
        if (n.children && n.children.length) {
          self.applyAdsBindMap(n.children, map);
        }
      });
    },
    handleAdsDeptBind(row) {
      if (!this.isSuperAdminUser) {
        return;
      }
      this.bindAiDeptId = row.id;
      this.bindDeptName = row.deptName || '';
      this.bindAdsDeptIdInput = row.adsDeptId != null && row.adsDeptId !== '' ? String(row.adsDeptId) : '';
      this.bindAdsDeptNameInput = row.adsDeptName ? String(row.adsDeptName) : '';
      this.bindOpen = true;
    },
    async loadAdsDeptOptions() {
      this.adsDeptOptionsLoading = true;
      try {
        var res = await fetchAdsDeptTree({ skipErrorMessage: true });
        this.adsDeptOptions = res && res.data ? res.data : [];
      } catch (e) {
        this.adsDeptOptions = [];
      } finally {
        this.adsDeptOptionsLoading = false;
      }
    },
    onAdsDeptSelect(val) {
      if (!val || val === '') {
        this.bindAdsDeptNameInput = '';
        return;
      }
      var id = Number(val);
      for (var i = 0; i < this.adsDeptOptions.length; i++) {
        if (this.adsDeptOptions[i].deptId === id) {
          this.bindAdsDeptNameInput = this.adsDeptOptions[i].deptName || '';
          return;
        }
      }
      this.bindAdsDeptNameInput = '';
    },
    resetBindForm() {
      this.bindAiDeptId = undefined;
      this.bindDeptName = '';
      this.bindAdsDeptIdInput = '';
      this.bindAdsDeptNameInput = '';
    },
    async submitDeptBind() {
      if (!this.bindAiDeptId) {
        return;
      }
      let adsDeptId = null;
      const raw = (this.bindAdsDeptIdInput || '').trim();
      if (raw !== '') {
        const n = parseInt(raw, 10);
        if (Number.isNaN(n) || n <= 0) {
          this.$message.warning('投放系统部门ID须为正整数');
          return;
        }
        adsDeptId = n;
      }
      this.bindSaving = true;
      try {
        var nameTrim = (this.bindAdsDeptNameInput || '').trim();
        var payload = { adsDeptId: adsDeptId };
        if (adsDeptId != null) {
          payload.adsDeptName = nameTrim === '' ? null : nameTrim;
        }
        await saveDeptAdsBind(this.bindAiDeptId, payload);
        this.$message.success('保存成功');
        this.bindOpen = false;
        await this.fetchList();
      } catch (e) {
        /* http 已提示 */
      } finally {
        this.bindSaving = false;
      }
    },
    /** 查询部门树结构 */
    async getTreeselect() {
      const response = await getDeptTree();
      this.deptOptions = response.data;
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        parentId: 0,
        deptName: undefined,
        sort: 0,
        leader: undefined,
        phone: undefined,
        email: undefined,
        status: 1
      };
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.fetchList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.query = {
        deptName: undefined,
        status: undefined
      };
      this.handleQuery();
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset();
      this.getTreeselect();
      if (row != undefined) {
        this.form.parentId = row.id;
      }
      this.open = true;
      this.title = "添加部门";
    },
    /** 展开/折叠操作 */
    toggleExpandAll() {
      this.refreshTable = false;
      this.isExpandAll = !this.isExpandAll;
      this.$nextTick(() => {
        this.refreshTable = true;
      });
    },
    /** 修改按钮操作 */
    async handleUpdate(row) {
      this.reset();
      this.getTreeselect();
      this.form = { ...row };
      this.open = true;
      this.title = "修改部门";
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          if (this.form.id != undefined) {
            await updateDept(this.form.id, this.form);
            this.$message.success("修改成功");
          } else {
            await createDept(this.form);
            this.$message.success("新增成功");
          }
          this.open = false;
          this.fetchList();
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm('是否确认删除名称为"' + row.deptName + '"的数据项？', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await deleteDept(row.id);
        this.fetchList();
        this.$message.success("删除成功");
      }).catch(() => {});
    },
    parseTime(time) {
        if (!time) return '';
        const date = new Date(time);
        const y = date.getFullYear();
        const m = (date.getMonth() + 1).toString().padStart(2, '0');
        const d = date.getDate().toString().padStart(2, '0');
        const h = date.getHours().toString().padStart(2, '0');
        const min = date.getMinutes().toString().padStart(2, '0');
        const s = date.getSeconds().toString().padStart(2, '0');
        return `${y}-${m}-${d} ${h}:${min}:${s}`;
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 0;
  background-color: #f8f8f9;
  min-height: calc(100vh - 84px);
}

.query-card {
  border: none;
}

.mb8 {
  margin-bottom: 8px;
}

.right-tool {
  float: right;
}

.el-button--mini {
  padding: 7px 15px;
}

.el-table th {
  background-color: #f8f8f9 !important;
  color: #515a6e;
}

.el-form-item__label {
  font-weight: 700;
}

.danger-text {
  color: #ff4d4f !important;
}

.danger-text:hover {
  color: #ff7875 !important;
}

.operation-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}

.operation-cell .el-button {
  margin: 0 5px;
}
</style>
